import { SUBJECT_ID_KEY, BANNER_DISMISSED_KEY } from './constants';

export class StorageManager {
  getSubjectId(): string {
    let id = localStorage.getItem(SUBJECT_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SUBJECT_ID_KEY, id);
    }
    return id;
  }

  setSubjectId(id: string): void {
    localStorage.setItem(SUBJECT_ID_KEY, id);
  }

  isBannerDismissed(): boolean {
    return localStorage.getItem(BANNER_DISMISSED_KEY) === 'true';
  }

  setBannerDismissed(): void {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
  }
}
